import { Mic, Pause, Play, Square, Volume2 } from "lucide-react";

import { AudioProcessingLoader } from "components/AudioProcessingLoader/AudioProcessingLoader";
import { Button } from "components/ui/Button";

import s from "./AudioRecorderSection.module.css";

export const AudioRecorderSection = ({
  isRecording,
  isProcessing,
  startRecording,
  stopRecording,
  audioUrl,
  isPlaying,
  audioRef,
  toggleAudioPlayback,
  hasAudioFile,
  onAudioEnded,
  onAudioPlay,
  onAudioPause,
}) => (
  <>
    <div className={s.controls}>
      <Button
        type="button"
        variant={isRecording ? "danger" : "outline"}
        size="large"
        onClick={isRecording ? stopRecording : startRecording}
        disabled={isProcessing}
      >
        {isRecording ? (
          <>
            <Square size={14} /> Stop Recording
          </>
        ) : isProcessing ? (
          <AudioProcessingLoader text="Processing..." />
        ) : (
          <>
            <Mic size={14} /> Record Audio
          </>
        )}
      </Button>
      <span className={s.betaNote}>(Audio recording is in beta testing)</span>
    </div>

    {isProcessing && (
      <div className={s.processingBanner}>
        <AudioProcessingLoader text="" />
        You cannot update the letter while the audio is processing, bear with us
        as processing Irish accents can take time
      </div>
    )}

    {audioUrl && hasAudioFile && (
      <div className={s.playbackSection}>
        <div className={s.playbackHeader}>
          <Volume2 size={16} className={s.volumeIcon} />
          <span className={s.playbackTitle}>Recorded Audio</span>
        </div>
        <Button
          type="button"
          variant="outline"
          size="small"
          onClick={toggleAudioPlayback}
        >
          {isPlaying ? (
            <>
              <Pause size={14} /> Pause
            </>
          ) : (
            <>
              <Play size={14} /> Play
            </>
          )}
        </Button>
        <audio
          ref={audioRef}
          src={audioUrl}
          onEnded={onAudioEnded}
          onPlay={onAudioPlay}
          onPause={onAudioPause}
          style={{ display: "none" }}
        />
      </div>
    )}

    {isProcessing && (
      <div className={s.reviewBanner}>
        We advise you review the output from the health scribe, as no one is
        perfect
      </div>
    )}
  </>
);
